<template>
  <div>
    <div class="form-control-item form-control-item--dropdown">
      <validation-provider
        :rules="item.validation"
        v-slot="{ errors, invalid, touched }"
      >
        <label v-if="!item.hideLabel" :for="`${item.key}-${item.id}`">
          {{ item.label }}
          <span v-if="item.required">*</span>
        </label>
        <div class="select-box">
          <select
            :id="`${item.key}`"
            :name="item.key"
            v-model="whereFound"
            :class="[
              { invalid: invalid },
              { touched: touched },
              { 'has-errors': errors.length > 0 },
            ]"
            :disabled="item.disabled"
          >
            <option v-if="!item.hideLabel" value="" selected disabled hidden>
              Please select...
            </option>
            <option v-else value="" selected disabled hidden>
              {{ item.label }}{{ item.required ? "*" : "" }}
            </option>
            <option
              v-for="option in item.options"
              :key="option.value"
              :value="option.value"
              :selected="whereFound === option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <span class="validation-label">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div
      v-if="showWhereFoundOther"
      class="form-control-item form-control-item--text"
    >
      <validation-provider
        rules="required"
        v-slot="{ errors, invalid, touched }"
      >
        <label :for="item.key"> Other<span>*</span> </label>
        <input
          v-model="whereFoundOther"
          :class="[
            { invalid: invalid },
            { touched: touched },
            { 'has-errors': errors.length > 0 },
          ]"
        />
        <span class="validation-label">
          {{ errors[0] }}
          <span v-if="errors.length > 0 && item.hint">({{ item.hint }})</span>
        </span>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import { registrationConfig } from "@/helpers/config";
import { useMemberDetails } from "@/helpers/member-details";
import { ref, watch } from "@vue/composition-api";
import { ValidationProvider } from "vee-validate";

export default {
  props: ["item"],
  components: { ValidationProvider },
  setup() {
    const showWhereFoundOther = ref(false);
    const whereFound = ref("");
    const whereFoundOther = ref("");
    const whereFoundOptions = Object.keys(
      registrationConfig.memWhereFoundTypes,
    ).map((key) => ({
      label: registrationConfig.memWhereFoundTypes[key],
      value: key,
    }));

    const memberDetails = useMemberDetails();
    const { setWhereFound } = useMemberDetails();

    watch(
      () => whereFound.value,
      (newVal) => {
        showWhereFoundOther.value = false;
        if (newVal !== "") {
          setWhereFound(whereFound.value, "");
          if (
            newVal ===
              whereFoundOptions.find((x) => x.label === "Other").value &&
            whereFoundOther.value === ""
          ) {
            showWhereFoundOther.value = true;
          }
        }
      },
    );

    watch(
      () => whereFoundOther.value,
      () => {
        if (showWhereFoundOther.value) {
          setWhereFound(whereFound.value, whereFoundOther.value);
        }
      },
    );

    return { memberDetails, whereFound, whereFoundOther, showWhereFoundOther };
  },
};
</script>

<style lang="scss" scoped>
select,
input {
  &.has-errors,
  &.invalid.touched {
    border-color: var(--error);
  }
}
</style>
